<template>
  <div id="myLogHome">
    <div>
      <div style="max-height: calc(100vh - 270px);overflow: auto;margin-top:20px;">
        <table class="allTable" cellspacing="0">
          <thead>
          <tr>
            <th width="20"></th>
            <th style="text-align: left">文件列表</th>
          </tr>
          </thead>
          <tbody :key="index" v-for="(item, index) in myList">
          <tr>
            <td width="20" colspan="4" class="f_w"  style="text-align: left">
              <i @click="onClickF(item)" class="icon iconfont iconicon_7 dis_line" :style="{'transform': item.isClickF ? '' : 'rotate(-90deg)'}" style="transition: all .5s"></i>
              <span class="m_l_10">{{ item.category }}</span>
            </td>
          </tr>
          <tr :key="indexCl" v-for="(itemCl, indexCl) in item.list" v-if="item.isClickF" @click="toUrl(itemCl)" class="c_p">
            <td width="20"></td>
            <td style="text-align: left">{{ itemCl.name }}</td>
          </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'myLogHome',
  data () {
    return {
      filename: '',
      myList: [
        {
          category: '操作日志',
          isClickF: true,
          list: [
            {
              id: 1,
              name: '用户操作日志'
            }
          ]
        },
        {
          category: '数据上传',
          isClickF: true,
          list: [
            {
              id: 2,
              name: '上传提醒邮件日志'
            }
          ]
        },
        {
          category: '数据下载',
          isClickF: true,
          list: [
            {
              id: 3,
              name: '发送/订阅邮件日志'
            },
            {
              id: 4,
              name: '下载明细日志'
            },
            {
              id: 5,
              name: '导出提醒日志'
            }
          ]
        }
      ]
    }
  },
  created () {
    // this.getAllList()
  },
  methods: {
    onClickF (item) {
      item.isClickF = !item.isClickF
    },
    toUrl (item) {
      this.$router.push({
        name: 'myLogHomeDetail',
        query: {
          formChildTableId: item.id,
          formName: item.name
        }
      })
    }
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/pages/mySystemMessager/myLogList.vue